import { faGripVertical } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { PropsWithChildren } from 'react';
import { useStyles } from './styles';
import { Card, CardContent, Grid } from '@material-ui/core';

interface IDragCard<T> {
  item: T;
  pos: number;
  onDragStart: (item: T, event: React.DragEvent<HTMLDivElement>) => void;
  onDragLeave: () => void;
  onDragOver: (event: React.DragEvent<HTMLDivElement>) => void;
  onDragDrop: (target: T, event: React.DragEvent<HTMLDivElement>) => void;
  isError?: boolean;
  isWarn?: boolean;
}

export const DragCard = <T,>({
  item,
  pos,
  onDragOver,
  onDragStart,
  onDragDrop,
  onDragLeave,
  children,
  isError,
  isWarn
}: PropsWithChildren<IDragCard<T>>) => {
  const styles = useStyles();
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    onDragDrop(item, event);
  };
  const handleDragStart = (event: React.DragEvent<HTMLDivElement>) => {
    onDragStart(item, event);
  };

  return (
    <Card
      onDragStart={handleDragStart}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDrop={handleDrop}
      className={styles.card}
      data-error={isError}
      data-warn={isWarn}
      draggable
    >
      <Grid component={CardContent} className={styles.cardContent} container alignItems="center">
        <div className={styles.cardGrip}>
          <FontAwesomeIcon icon={faGripVertical} className={styles.icon} />
          <strong>{pos}</strong>
        </div>
        {children}
      </Grid>
    </Card>
  );
};
